import dayjs from "dayjs";

let helper = {
    date(value) {
        if (!value) {
            return '';
        }
        return dayjs(Number(value)).format('YYYY-MM-DD');
    },
}
export default helper;